"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FormGroupFooter = function FormGroupFooter(_ref) {
  var label = _ref.label,
    submitter = _ref.submitter;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "primary",
    onClick: submitter
  }, label));
};
FormGroupFooter.propTypes = {
  displayName: _propTypes.default.string,
  label: _propTypes.default.string
};
FormGroupFooter.defaultProps = {
  displayName: 'formGroupFooter',
  label: 'Onayla'
};
var FormGroup = /*#__PURE__*/function (_React$Component) {
  function FormGroup(props) {
    var _this;
    (0, _classCallCheck2.default)(this, FormGroup);
    _this = _callSuper(this, FormGroup, [props]);
    _this.forms = {};
    return _this;
  }
  (0, _inherits2.default)(FormGroup, _React$Component);
  return (0, _createClass2.default)(FormGroup, [{
    key: "submitForms",
    value: function submitForms(e) {
      var _this2 = this;
      e.preventDefault();
      this.validateFields(function (error, data) {
        if (_this2.props.onSubmit) _this2.props.onSubmit(error, data);
      });
    }
  }, {
    key: "validateFields",
    value: function validateFields(cb) {
      var formRefs = this.forms;
      var data = {};
      var error = null;
      var _loop = function _loop(i) {
        formRefs[i].form.validateFields(function (err, values) {
          if (err) {
            error = _objectSpread(_objectSpread({}, error), (0, _defineProperty2.default)({}, formRefs[i].props.name, err));
          }
          data[formRefs[i].props.name] = values;
        });
      };
      for (var i in formRefs) {
        _loop(i);
      }
      cb(error, data);
    }
  }, {
    key: "renderForms",
    value: function renderForms() {
      var _this3 = this;
      return _react.default.Children.map(this.props.children, function (child, index) {
        if (child.props['name'] && child.props['name'].length > 0) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            ref: function ref(_ref2) {
              return _this3.forms[index] = _ref2;
            }
          });
        } else if (child.props.displayName === 'formGroupFooter') {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            submitter: function submitter(e) {
              return _this3.submitForms(e);
            }
          });
        } else {
          return;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ykb-form--multiple"
      }, this.renderForms());
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(FormGroup, "SubmitBtn", FormGroupFooter);
var _default = exports.default = FormGroup;
FormGroup.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  onSubmit: _propTypes.default.func,
  ref: _propTypes.default.object
};